import React, { FC } from 'react';
import { View, Text, StyleProp, ViewStyle } from 'react-native';
import i18n from 'i18n-js';
import { scale as initialScale } from '@components/frame';

import { font as initialFont } from '@styles/fonts';
import ColorsWrapper from '@styles/colors';
import { isPhone } from '@helpers';
import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';

interface ProcessingProps {
  C: ColorFunction;
  scale?: ScaleFunction;
  font?: typeof initialFont;
  containerStyles?: StyleProp<ViewStyle>;
}

const Processing: FC<ProcessingProps> = ({ C, scale = initialScale, font = initialFont, containerStyles }) => (
  <View
    style={[
      {
        position: 'absolute',
        height: scale(22),
        width: '100%',
        bottom: scale(isPhone ? 135 : 65),
        zIndex: 10000,
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
      },
      containerStyles,
    ]}
  >
    <View
      style={{
        height: scale(22),
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        backgroundColor: C('Overlay/Light/Text Area On Picture'),
        flexDirection: 'row',
        borderRadius: scale(10),
        paddingHorizontal: scale(12),
      }}
    >
      <Text style={[font.Footnote, { color: C('Label/Light/AlwaysLight Primary'), marginLeft: scale(5) }]}>{i18n.t('Processing...')}</Text>
    </View>
  </View>
);

export default ColorsWrapper(Processing);
